@@include('../../plugins/pixel.min.js')
@@include('../../plugins/amplitude.min.js')